module.exports = __webpack_public_path__ + "static/media/5f8de7ec5ae7590275f074d6_banner_800x600.43c23836.png";